import fr from '_business/translations/fr';

export default { fr };
